import { useReducer } from 'react'

export const actionTypes = {
  OPEN_EXPORT_CSV_DIALOG: 'OPEN_EXPORT_CSV_DIALOG',
  OPEN_EXPORT_PDF_DIALOG: 'OPEN_EXPORT_PDF_DIALOG',
  CLOSE_EXPORT_DIALOG: 'CLOSE_EXPORT_DIALOG',
}

const initialState = {
  isOpenExportDialog: false,
  title: '',
  message: '',
  isCSV: false,
  isPDF: false,
}

const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.OPEN_EXPORT_CSV_DIALOG: {
      return {
        ...state,
        isOpenExportDialog: true,
        title: action.title,
        message: action.message,
        isCSV: true,
        isPDF: false,
      }
    }
    case actionTypes.OPEN_EXPORT_PDF_DIALOG: {
      return {
        ...state,
        isOpenExportDialog: true,
        title: action.title,
        message: action.message,
        isPDF: true,
        isCSV: false,
      }
    }
    case actionTypes.CLOSE_EXPORT_DIALOG: {
      return {
        isOpenExportDialog: false,
        title: '',
        message: '',
        isCSV: false,
        isPDF: false,
      }
    }
    default: {
      throw new Error('Not supported action')
    }
  }
}

export const useExportDialog = () => {
  const [{ isOpenExportDialog, title, message, isPDF, isCSV }, dispatch] =
    useReducer(reducer, initialState)

  return {
    actionTypeDialog: actionTypes,
    isOpenExportDialog,
    title,
    message,
    isPDF,
    isCSV,
    onShowDialogExport: dispatch,
  }
}
